'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.weeksAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/weeksAgo.js
// module id = 295
// module chunks = 1